<input
  type="button"
  onclick="window.print()"
  class="btn btn-danger noprint"
  value="Afdrukken"
/>
<app-print-menuitem *ngFor="let mi of menuItems" [menuItem]="mi">
</app-print-menuitem>
